var $ = require('jquery');
var $script = require('scriptjs');

$script('//connect.facebook.net/en_US/all.js', function () {
    var init = function () {
        FB.init({
            appId      : '732722133488972',
            xfbml      : true,
            version    : 'v2.0'
        });
    };

    var share = function (e) {
        e.preventDefault();
        var url = $(this).data('url'),
            href = url ? url : window.location.href;
        FB.ui({
            method: 'share',
            href: href,
        }, function(response){});
    };

    $(function () {
        init();
        $(document).on('click', '.fb-share', share);
        // Google analytics event submission
        $(document).on('click', '.share-button', function(e) {
            ga('send', 'event', $(this).data('media'), 'share', $(this).data('title'));
        });
    });
});



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/facebook.js
// module id = 6
// module chunks = 0